<template>
    <div class="p-4 mb-4 bg-white border shadow-lg dark:border-gray-200 dark:border dark:bg-gray-800 md:flex rounded-3xl border-clay-200">

        <a :href="`/${scene.urlSlug}`"
               :alt="scene.showTitle"
               :title="`${scene.showTitle} scene snippet`" 
            class="shrink-0 guide-img-container">
            <img class="object-cover w-20 h-20 mx-auto md:w-32 md:h-32 rounded-3xl" :src="scene.showLogo"
                     :alt="`${scene.showTitle} logo`"
                     :title="`${scene.showTitle} logo`">
        </a>


        <div class="justify-between flex-1 ml-4 md:flex md:flex-col">
            <div class="items-center flex-none mb-2">

                <a  :href="`/${scene.urlSlug}`"
               :alt="scene.showTitle"
               :title="`${scene.showTitle} scene snippet`" 
                    class="inline-block text-sm font-medium text-gray-900 text-md hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2 md:block">
                    <h3 class="">{{ scene.getExcerptOrDefault?.substring(0, 30) }}...</h3>
                </a>
                <p>
                    <em class="visible ml-1 text-xs lg:ml-0 lg:invisible">(</em>
                    <em class="text-sm text-gray-900 ">
                        <span class="tag-list">
                            <a v-for="character in scene.characters" :key="character.id" :alt="character.name" :title="character.name"
                               class="mr-1 text-sm text-gray-900" :href="`/${character.id}`">{{ character.name }}</a>

                        </span>
                    </em>
                    <em class="visible text-xs lg:invisible">)</em>
                </p>
                <p><a  :href="`/${scene.urlSlug}`" :alt="scene.showTitle" :title="`${scene.showTitle} scene snippet`"
                        class="text-sm text-slate-800">{{ scene.showTitle }}</a>
                </p>
                <div class="space-y-2">
                    <div v-if="scene.displaysFullText"
                        class="block pb-2 my-2 text-xs text-gray-600 md:inline-block">
                        <span
                            class="px-2 py-1 mx-1 mb-2 text-xs font-medium rounded-full text-clay-950 bg-clay-50 dark:border">
                            Text
                        </span>
                    </div>
                    <dd v-if="scene.hasVideos" class="block pb-2 my-2 text-xs text-gray-600 md:inline-block">
                        <span
                            class="px-2 py-1 mx-1 mb-2 text-xs font-medium rounded-full text-clay-950 bg-clay-50 dark:border">
                            Video
                        </span>
                    </dd>
                </div>
            </div>
            <div class="justify-between sm:flex">
                <div class="mr-4">



                </div>
                <div>
                    <div class="mt-2 ml-4 shrink-0 md:mt-0">
                        <div class="grid grid-cols-2 mt-4 space-x-1 text-sm text-center sm:text-left sm:mt-0">
                            <Fanning :id="scene.id" :number-of-fans="scene.fanCount"></Fanning>
                            <Bookmarking :id="scene.id"></Bookmarking>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>


<script lang="ts" setup>
import {defineProps} from "vue";
import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {SceneDto} from "@/dtos";

const props = defineProps<{
    scene: SceneDto,
}>();

const scene: SceneDto = props.scene;

</script>
<style>

</style>